const { parse } = require("path");

$('.Tabs').each(function(i, tab) {
    var tabRoot = $(this);
    var tabNumber = $('.TabHead').children().length;
    var tabPercentage = parseInt(100 / tabNumber);
    var tabTrigger = '.TabTrigger';
    var tabContent = '.TabContent';
    var findTabTrigger = tabRoot.find(tabTrigger);
    var findTabContent = tabRoot.find(tabContent);
    var currentTab = $('.TabTrigger.__active').index() + 1;
    var tabProgress = currentTab * tabPercentage;
    var progressBar = '.TabProgressBar';

    findTabTrigger.attr('aria-selected', false);
    findTabContent.attr('aria-expanded', false);

    findTabTrigger.eq(0).addClass('__active').attr('aria-selected', true);
    findTabContent.eq(0).addClass('__active').attr('aria-expanded', true);

    findTabTrigger.click(function(e) {
        e.preventDefault();
        var dataSet = $(this).data('set');

        tabRoot.find(tabTrigger + '.__active').attr('aria-selected', false).removeClass('__active');
        $(this).attr('aria-selected', true).addClass('__active');

        tabRoot.find(tabContent + '.__active').attr('aria-expanded', false).removeClass('__active');
        tabRoot.find(tabContent + '[data-set="' + dataSet + '"]').attr('aria-expanded', true).addClass('__active');
    });

});

// Progress bar for selected tab
$('.TabTrigger').click(function() {
    var tabNumber = $('.TabHead').children().length;
    var tabPercentage = parseInt(100 / tabNumber);
    var tabIndex = $('.TabTrigger').index();
    var currentTab = $('.TabTrigger.__active').index();
    var tabProgress = currentTab * tabPercentage;
    var progressBar = '.TabProgressBar';

    $(progressBar).css('width', tabProgress + '%');

    // Marks previous tab as complete
    if (currentTab > tabIndex) {
        $(this).prev().addClass('__complete');
    }
});


